import React from 'react';

import { EditOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { RetrieveUserGroupSchema } from '@app/models/users';

import { useGroups } from '../../../providers';
import { NEW_GROUP_ID } from '../../../providers/constants';

interface IProps {
  record: RetrieveUserGroupSchema;
}

export const EditAction: React.FC<IProps> = ({ record }) => {
  const commonT = useTranslation(NSKeys.common);
  const { editingRowKey, onEditRow } = useGroups();

  if (record.uid === NEW_GROUP_ID || !record?.$permissions?.update || !!editingRowKey) {
    return null;
  }

  return (
    <Tooltip title={commonT.t('edit')}>
      <Button type="link" icon={<EditOutlined />} onClick={() => onEditRow(record.uid)} />
    </Tooltip>
  );
};
